import {
  isValidWorkbenchNavId,
  navigateWorkbenchWithState,
  normalizeWorkbenchNavId,
} from '@/pages/ipe/workbench/constants/workbenchNavConfig';

export function navigateDetailToWorkbench(navigate, navId, extraState = {}, options = {}) {
  navigateWorkbenchWithState(navigate, navId, extraState, options);
}

export function navigateDetailBack(navigate, backNavId, locationState = null) {
  const fromHistory = locationState?.fromHistory;
  const preferred = normalizeWorkbenchNavId(fromHistory?.navId || backNavId);
  const fallback = normalizeWorkbenchNavId(backNavId);
  const targetNavId = isValidWorkbenchNavId(preferred) ? preferred : fallback;
  if (!isValidWorkbenchNavId(targetNavId)) return;
  navigateWorkbenchWithState(
    navigate,
    targetNavId,
    fromHistory ? { restoreHistoryPanel: { ...fromHistory, navId: targetNavId } } : {},
  );
}

export function navigateDetailReuse(navigate, backNavId, reuseStateKey, prefill) {
  navigateWorkbenchWithState(navigate, backNavId, {
    [reuseStateKey]: { ...prefill, navId: backNavId },
  });
}

export function navigateDetailToMaterialLibrary(navigate, materialBatchId) {
  navigateWorkbenchWithState(navigate, 'systemMaterialLibrary', {
    materialBatchId: materialBatchId || undefined,
  });
}

export function navigateDetailToAccountCenter(navigate) {
  navigateWorkbenchWithState(navigate, 'accountCenter');
}

export function navigateDetailToTeamManagement(navigate) {
  navigateWorkbenchWithState(navigate, 'teamManagement');
}

export function navigateDetailToOrderCenter(navigate) {
  navigateWorkbenchWithState(navigate, 'orderCenter');
}

export function navigateDetailToOpenKeys(navigate) {
  navigateWorkbenchWithState(navigate, 'openKeys');
}
